__turbopack_context__.v({
  "close": "footnote-module-scss-module__frQu6a__close",
  "footnote": "footnote-module-scss-module__frQu6a__footnote",
  "modal": "footnote-module-scss-module__frQu6a__modal",
});
